export default "__VITE_ASSET__9DJjiWVh__"